import { useAtomValue } from 'jotai';
import { gigsAtom } from '../../atoms';

export const useAgencyGigs = () => useAtomValue(gigsAtom);
